"use client";
import React, { useRef, useEffect } from "react";

const steps = [
  { num: "01", title: "Book via WhatsApp", desc: "Send a quick message to schedule your session." },
  { num: "02", title: "Share Your Concern", desc: "Tell me what area of life you need clarity in." },
  { num: "03", title: "Get Personalized Insights", desc: "Receive a deep, intuitive reading tailored to you." },
  { num: "04", title: "Receive Guidance & Clarity", desc: "Walk away with actionable steps and renewed energy." },
];

const HowItWorksSection: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const itemsRef = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.remove("card-hidden");
            entry.target.classList.add("card-reveal");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    itemsRef.current.forEach((item) => {
      if (item) {
        item.classList.add("card-hidden");
        observer.observe(item);
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section id="how-it-works" ref={sectionRef} className="relative py-20 md:py-28 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <span className="section-label">Process</span>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl text-foreground mt-4">
            How It Works
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {steps.map((step, i) => (
            <div
              key={i}
              ref={(el) => { itemsRef.current[i] = el; }}
              className="flex gap-5 items-start"
            >
              <span className="step-number">{step.num}</span>
              <div className="pt-3">
                <h3 className="font-display text-xl text-foreground mb-1">{step.title}</h3>
                <p className="text-foreground-muted text-sm font-body leading-relaxed">
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
